import useIsNLplan from '../../../common/src/hooks/useIsNLPlan';
import {
  flowIdShortCheckupCustomerBE,
  flowIdShortCheckupCustomerNL,
} from '../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../flows/src/hooks/useFlowsResetState';

const useStartShortCheckupCustomerFlow = () => {
  const { isNL } = useIsNLplan();
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (
    uuid?: string,
    inputUrl?: string,
    partyId?: string,
    quoteId?: string,
  ) => {
    reset();

    await initFlow({
      flowId: isNL
        ? flowIdShortCheckupCustomerNL
        : flowIdShortCheckupCustomerBE,
      payload: {
        party_id: partyId,
        quote_id: quoteId,
      },
      inputUrl,
      outputUrl: `/sales-conversation/customer-checkup/finalize`,
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartShortCheckupCustomerFlow;
